export default __webpack_public_path__ + "assets/phone.024ae732.svg";